module.exports = __webpack_public_path__ + "img/sense_offline.fb3d4e7e.png";